import ReadReportInstancesCriteria from 'use-case/reportsInstances/read/readReportInstancesCriteria';
import { ReportInstance } from 'domain/entity/reportInstance';
import getGenericUseCase from 'use-case/genericUseCase';

const readReportInstancesUseCase = getGenericUseCase<ReportInstance[], ReadReportInstancesCriteria>((client, criteria) => client(criteria));

export default readReportInstancesUseCase;
